import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from '../locales/ar.json';
import fr from '../locales/fr.json';
import en from '../locales/en.json';

const savedLanguage = localStorage.getItem('language') || 'ar';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            ar: { translation: ar },
            fr: { translation: fr },
            en: { translation: en },
        },
        lng: savedLanguage,
        fallbackLng: 'ar',
        interpolation: {
            escapeValue: false,
        },
    });

// Update document direction based on language
i18n.on('languageChanged', (lng) => {
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lng;
    localStorage.setItem('language', lng);
});

// Set initial direction
document.documentElement.dir = savedLanguage === 'ar' ? 'rtl' : 'ltr';
document.documentElement.lang = savedLanguage;

export default i18n;
